import { AtomBox, Text } from '@pancakeswap/uikit'
import { NumericalInput } from '@pancakeswap/widgets-internal'
import { ReactNode } from 'react'

export const CurrencyInput = ({
  title,
  value,
  top,
  content,
  bottom,
  error,
  disabled,
  loading,
  onBlur,
  onUserInput,
}: {
  title: ReactNode
  value: string | undefined
  top: ReactNode
  content: ReactNode
  bottom: ReactNode
  error: string | undefined | boolean
  disabled: boolean | undefined
  loading: boolean | undefined
  onBlur: (() => void) | undefined
  onUserInput: (val: string) => void
}) => {
  return (
    <div className={'relative flex flex-col border rounded-3xl bg-card p-4'}>
      <div className="flex items-center justify-between mb-4">
        <div className={'text-card-foreground'}>{title}</div>
        {top}
      </div>
      <div className={'flex items-center my-2'}>
        {content}
        <NumericalInput
          error={Boolean(error)}
          disabled={disabled}
          loading={loading}
          className="token-amount-input text-4xl! text-primary!"
          value={value}
          onBlur={onBlur}
          onUserInput={(val) => {
            onUserInput(val)
          }}
        />
      </div>
      {bottom}

      {error ? (
        <Text pb="8px" fontSize="12px" color="red">
          {error}
        </Text>
      ) : null}

      {disabled && (
        <AtomBox role="presentation" position="absolute" inset="0px" backgroundColor="backgroundAlt" opacity="0.6" />
      )}
    </div>
  )
}
